import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { BackendDownBanner } from './core/backend-status/backend-down-banner';
import { BypassActiveBanner } from './core/bypass-status/bypass-active-banner';
import { ToastContainer } from './shared/toast/toast-container';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, BackendDownBanner, BypassActiveBanner, ToastContainer],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {}
